
import { LockDec, ValidateDec } from '@/decorators';
import { Component, Prop, Vue } from 'vue-facing-decorator'
@Component({})
export default class extends Vue {
  ruleList = []

  loading = false;
  submitLoading = false;

  formData = {
    id: undefined,
    name: "",
    phone: "",
    /** 一个员工只能有一个角色，null 表示无角色 */
    roleId: null,
  }

  async created() {
    this.getRuleList();
    this.loading = true;
    await this.getData();
    this.loading = false;
  }

  async getRuleList() {
    let { error, data } = await this.$post("/manager/role/list", {
      pageSize: 100000,
    });
    if (error) return;
    this.ruleList = data.list;
  }
  async getData() {
    let id = this.$route.query.id;
    if (!id) return;
    let { error, data } = await this.$get("/manager/staff/info", { id });
    if (error) return;
    this.formData = data;
  }

  @LockDec("submitLoading")
  @ValidateDec('form')
  async submit() {
    if (this.formData.id) {
      await this.$postNotify("/manager/staff/edit", {
        ...this.formData,
      });
    } else {
      await this.$postNotify("/manager/staff/add", {
        ...this.formData,
      });
    }
    this.$router.back();
  }
}
